/**
 * ═══════════════════════════════════════════════════════════════════════
 * FONDASYON FELICITEE — FICHIER CENTRAL DES TEXTES DU SITE
 * ═══════════════════════════════════════════════════════════════════════
 *
 * 📝 COMMENT MODIFIER LES TEXTES DU SITE ?
 *
 * Ce fichier contient TOUS les textes visibles sur la page d'accueil.
 * Pour modifier un texte :
 *   1. Trouvez la section concernée (navbar, hero, projets, about, etc.)
 *   2. Modifiez uniquement le texte entre les guillemets
 *   3. NE TOUCHEZ PAS aux noms de clés (ex: "titre:", "description:")
 *   4. Sauvegardez — le site se met à jour automatiquement
 *
 * ⚠️  Attention : gardez toujours les guillemets " " et les virgules
 * ⚠️  Pour une apostrophe dans un texte, utilisez \' (ex: "l\'avenir")
 * ═══════════════════════════════════════════════════════════════════════
 */

export const siteContent = {
  // ─── BARRE UTILITAIRE (HAUT) ───────────────────────────────────────
  topBar: {
    paymentOptions: "Options de paiement",
    termsConditions: "Conditions générales",
    location: "Port-au-Prince, Ayiti",
    email: "info@fondasyonfelicitee.org",
  },

  // ─── NAVIGATION PRINCIPALE ─────────────────────────────────────────
  navbar: {
    menuItems: [
      { label: "Accueil", href: "#home", active: true },
      { label: "La Fondasyon", href: "/la-fondasyon", active: false },
      { label: "Nos Activités", href: "#activities", active: false, hasMegaMenu: true },
      { label: "Events", href: "#events", active: false },
      { label: "Boutique", href: "#boutique", active: false },
      { label: "Contact", href: "#contact", active: false },
    ],
    donateButton: "Faire un don",
    megaMenu: {
      title: "Nos activités",
      programs: [
        "KOMALFA",
        "KOMFESAY",
        "KOMJKT",
        "KOMRISTORICH",
        "KOMRSL",
        "KOMSEMAKTO",
        "GALERIE DES Aïeules et Aïeux",
      ],
      featuredCard1: {
        badge: "Projet Phare",
        title: "KOMALFA",
        description: "Notre programme phare de reforestation et de préservation de la biodiversité locale.",
        button: "Découvrir",
      },
      featuredCard2: {
        badge: "Mémoire & Patrimoine",
        title: "Galerie des Aïeux",
        description: "Préserver l'héritage et les archives précieuses de ceux qui ont façonné notre identité.",
        button: "Visiter",
      },
    },
  },

  // ─── SECTION HERO (GRANDE BANNIÈRE D'ACCUEIL) ──────────────────────
  hero: {
    badge: "FONDASYON FELICITEE",
    titreLigne1: "Honorer le passé,",
    titreLigne2: "Bâtir l'avenir",
    description:
      "Préserver l'héritage architectural et spirituel d'Ayiti tout en soutenant nos aînés et en formant les leaders de demain.",
    boutonPrimaire: "Faire un don",
    boutonSecondaire: "En savoir plus",
  },

  // ─── SECTION "NOS PROJETS PHARES" ──────────────────────────────────
  projetsPhares: {
    titre: "Nos projets phares",
    projets: [
      {
        tagline: "Helping today",
        titre: "Soutenez le Jardin de plantes médicinales",
        description:
          "Mise en pratique des savoirs thérapeutiques Ayitiens pour une autonomie santé préservée au sein de nos communautés locales.",
        pourcentage: 62,
        montantCollecte: "$9,183",
        objectif: "$15,000",
      },
      {
        tagline: "Helping today",
        titre: "Contribuez à la Galerie des Aïeux",
        description:
          "Nous valorisons la mémoire et l'héritage de ceux qui ont tracé le chemin de notre liberté. Participez à la numérisation des archives.",
        pourcentage: 100,
        montantCollecte: "$15,000",
        objectif: "$15,000",
      },
      {
        tagline: "Helping today",
        titre: "Urgence : Soutien aux centenaires",
        description:
          "Nous accompagnons grâce à vos dons, nos aînés de 100 ans et plus dans leur dignité quotidienne : soins, nutrition et confort.",
        pourcentage: 91,
        montantCollecte: "$13,646",
        objectif: "$15,000",
      },
    ],
  },

  // ─── SECTION "À PROPOS — DE LA MÉMOIRE À L'ACTION" ─────────────────
  about: {
    surtitre: "ABOUT US",
    titre: "De la mémoire à l'action",
    statBadge: {
      nombre: "+25",
      label: "Années d'action",
    },
    paragraphe1:
      "FONDASYON FELICITEE est une organisation à but non lucratif créée en 1999 à Ayiti et étendue officiellement aux États-Unis en 2021 pour amplifier son impact auprès de la diaspora.",
    paragraphe2:
      "Notre mission est de populariser l'histoire des enfants d'Afrika/Meritah/Alkebulan, de préserver la mémoire de nos Ancêtres et de transformer cette connaissance en actions concrètes. Nous honorons la sagesse des aînés pour guérir, éduquer afin de libérer l'avenir de nos enfants, intervenant pour la santé, la justice, l'éducation et la prospérité.",
    citation:
      "La reconstruction d'Ayiti passe par la reconquête de notre mémoire et le respect de nos aînés, socles de notre humanité.",
    citationAuteur: "Mama Bayyinah Bello",
    citationFonction: "Co-Fondatrice",
  },

  // ─── BANNIÈRE 3 COLONNES (HAÏTI / CITATION / COMMUNAUTÉ) ───────────
  banniere: {
    badgeGauche: "HAÏTI",
    citation:
      "Rejoignez notre communauté et soutenez nos programmes pour bâtir un présent plus fort et un futur meilleur.",
    brandLigne1: "FONDASYON FELICITEE",
    brandLigne2: "DEPUIS 1999 · HAÏTI & USA",
    bouton: "DEVENEZ VOLONTAIRE",
    badgeDroite: "NOTRE COMMUNAUTÉ",
  },

  // ─── SECTION "UBUNTU EN ACTION" (STATISTIQUES) ─────────────────────
  ubuntu: {
    titre: "UBUNTU EN ACTION",
    sousTitre: "De la mémoire à l'action, de l'action aux résultats",
    stats: [
      { nombre: "120+", label: "Centenaires", icone: "volunteer_activism" },
      { nombre: "45+", label: "Tombes restaurées", icone: "temple_buddhist" },
      { nombre: "2500+", label: "Jeunes formés", icone: "school" },
      { nombre: "300+", label: "Ateliers", icone: "groups" },
    ],
  },

  // ─── SECTION "NOS ÉVÉNEMENTS" ──────────────────────────────────────
  evenements: {
    accroche: "Nos temps forts culturels",
    titre: "NOS ÉVÉNEMENTS",
    description:
      "Participez à nos rassemblements communautaires, conférences et célébrations culturelles. Chaque événement est une opportunité de célébrer notre héritage et de renforcer les liens qui nous unissent pour bâtir l'avenir d'Ayiti.",
    liste: [
      {
        mois: "Oct",
        jour: "12",
        categorie: "Conférence",
        titre: "Mémoire & Identité",
        horaire: "14:00 - 18:00",
      },
      {
        mois: "Nov",
        jour: "05",
        categorie: "Exposition",
        titre: "Galerie des Aïeux",
        horaire: "10:00 - 19:00",
      },
      {
        mois: "Nov",
        jour: "22",
        categorie: "Atelier",
        titre: "Sagesse des Aînés",
        horaire: "09:00 - 12:00",
      },
      {
        mois: "Dec",
        jour: "02",
        categorie: "Formation",
        titre: "Leaders de Demain",
        horaire: "11:00 - 15:00",
      },
      {
        mois: "Dec",
        jour: "18",
        categorie: "Célébration",
        titre: "Gala de Solidarité",
        horaire: "19:00 - 23:00",
      },
    ],
  },

  // ─── SECTION "CHANGEONS L'AVENIR ENSEMBLE" ─────────────────────────
  engagement: {
    titre: "Changeons l'avenir ensemble",
    boutons: [
      { label: "Je donne", icone: "volunteer_activism" },
      { label: "Je deviens volontaire", icone: "handshake" },
      { label: "Je partage", icone: "hub" },
    ],
  },

  // ─── FOOTER (PIED DE PAGE PREMIUM) ─────────────────────────────────
  footer: {
    // Bandeau newsletter
    newsletter: {
      accroche: "Restons connectés",
      titre: "Rejoignez notre",
      titreAccent: "cercle d'Ubuntu",
      description: "Recevez nos histoires, événements et appels à l'action directement dans votre boîte.",
      placeholder: "Votre adresse email",
      bouton: "S'ABONNER",
    },

    // Colonne marque
    brand: {
      badge: "Depuis 1999",
      nomLigne1: "FONDASYON",
      nomLigne2: "FELICITEE",
      description:
        "Organisation à but non lucratif dédiée à la préservation de la mémoire ancestrale d'Ayiti et à la construction d'un avenir digne pour ses enfants, de la diaspora à la patrie.",
      statut: "501(c)(3) · USA & Haïti",
    },

    // Colonne navigation
    navigation: {
      titre: "Naviguer",
      liens: [
        { label: "Accueil", href: "#home" },
        { label: "La Fondasyon", href: "/la-fondasyon" },
        { label: "Nos Activités", href: "#activities" },
        { label: "Événements", href: "#events" },
        { label: "Boutique", href: "#boutique" },
        { label: "Contact", href: "#contact" },
      ],
    },

    // Colonne programmes
    programmes: {
      titre: "Nos Programmes",
      liens: [
        "KOMALFA — Alphabétisation",
        "KOMFESAY — Centenaires",
        "KOMJKT — Entrepreneuriat",
        "KOMRISTORICH — Recherche",
        "KOMRSL — Histoire vivante",
        "Galerie des Aïeux",
      ],
    },

    // Colonne contact
    contact: {
      titre: "Nous joindre",
      siegeLabel: "Siège — Ayiti",
      siegeAdresse: "Port-au-Prince, Haïti",
      chapitreLabel: "Chapitre — USA",
      chapitreAdresse: "Fondé en 2021",
      email: "info@fondasyonfelicitee.com",
      telephone: "+1 786-757-7866",
      boutonDon: "FAIRE UN DON",
    },

    // Modes de paiement
    paiements: {
      titre: "Soutenez-nous via",
      methodes: [
        "Zelle · +1 786-757-7866",
        "PayPal",
        "CashApp · $FONDASYONFELICITEE",
        "MonCash",
        "NatCash",
      ],
    },

    // Barre légale
    legal: {
      copyright: "© 2026",
      nom: "FONDASYON FELICITEE",
      mention: "Tous droits réservés · Honorer le passé, bâtir l'avenir.",
      liens: ["Mentions légales", "Confidentialité", "Conditions"],
    },
  },
};

export type SiteContent = typeof siteContent;
